var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgTrafficCone = function SvgTrafficCone(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 140 140",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70.07,
    r: 60,
    fill: "#EDF0F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.6 57.07C133.875 81.0576 123.997 105.838 103.668 119.619C83.3381 133.401 56.6619 133.401 36.3323 119.619C16.0028 105.838 6.12533 81.0576 11.4 57.07H128.6Z",
    fill: "#E6EBED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.34 89.99L70.58 72.87L113.66 89.99L70.58 109.5L26.34 89.99Z",
    fill: "#8297A1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.17 89.81C53.0033 69.0834 59.8266 48.3467 66.64 27.6C67.7703 28.3906 69.1108 28.8258 70.49 28.85C71.9373 28.8653 73.3545 28.436 74.55 27.62L91.8 89.62C77.9115 98.512 60.1397 98.5938 46.17 89.83L46.17 89.81Z",
    fill: "#9BADB5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.58 109.5V113.5L26.34 93.32V89.99L70.58 109.5Z",
    fill: "#9BADB5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.58 113.57L113.66 93.32V89.99L70.58 109.5V113.57Z",
    fill: "#6D8491"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4 40.5C64.8729 41.2018 67.4295 41.5651 70 41.58C72.7543 41.6113 75.4989 41.2476 78.15 40.5L80.37 48.57C77.059 49.8934 73.5257 50.5723 69.96 50.57C66.4612 50.5516 62.9972 49.873 59.75 48.57L62.4 40.5Z",
    fill: "url(#paint0_linear_60_9805)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6 27.74C66.6 28.34 68.48 28.83 69.89 28.92C72.07 29.05 74.55 28.3 74.55 27.62C74.55 26.94 72.06 26.21 69.88 26.41C68.42 26.55 66.58 27.14 66.6 27.74Z",
    fill: "#8297A1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4 58.72C65.1774 61.0804 74.4226 61.0804 83.2 58.72L86.09 69.11C75.5005 73.553 63.5695 73.553 52.98 69.11L56.4 58.72Z",
    fill: "url(#paint1_linear_60_9805)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3 38.91C52.1581 38.9925 51.9912 39.0209 51.83 38.99L39.6 36.83C39.4175 36.7984 39.2554 36.6948 39.1501 36.5425C39.0447 36.3901 39.0051 36.2019 39.04 36.02C39.0717 35.8369 39.1749 35.674 39.3269 35.5671C39.4788 35.4602 39.667 35.4181 39.85 35.45L52.08 37.61C52.2625 37.6416 52.4246 37.7452 52.5299 37.8975C52.6353 38.0498 52.6749 38.2381 52.64 38.42C52.6096 38.6275 52.4838 38.8089 52.3 38.91Z",
    fill: "#FBD149"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6 33.01C54.3726 33.1604 54.0774 33.1604 53.85 33.01L43.68 25.85C43.5209 25.743 43.4127 25.5755 43.3805 25.3865C43.3484 25.1975 43.3952 25.0036 43.51 24.85C43.615 24.6885 43.7828 24.5783 43.9728 24.546C44.1627 24.5137 44.3575 24.5623 44.51 24.68L54.67 31.8C54.8307 31.9054 54.9409 32.0722 54.975 32.2613C55.009 32.4504 54.9638 32.6452 54.85 32.8C54.7856 32.8899 54.6996 32.9621 54.6 33.01Z",
    fill: "#FBD149"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8 38.91C86.9459 38.9916 87.1156 39.0198 87.28 38.99L99.5 36.83C99.6831 36.7983 99.846 36.6951 99.9529 36.5431C100.06 36.3912 100.102 36.203 100.07 36.02C99.999 35.6419 99.6398 35.3892 99.26 35.45L87 37.61C86.7147 37.6684 86.4941 37.8951 86.4434 38.1819C86.3926 38.4686 86.5221 38.7572 86.77 38.91H86.8Z",
    fill: "#FBD149"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M84.51 33.01C84.7374 33.1603 85.0326 33.1603 85.26 33.01L95.43 25.89C95.5891 25.783 95.6973 25.6155 95.7294 25.4265C95.7616 25.2375 95.7148 25.0436 95.6 24.89C95.4949 24.7285 95.3272 24.6183 95.1372 24.586C94.9473 24.5537 94.7525 24.6023 94.6 24.72L84.45 31.83C84.2909 31.937 84.1827 32.1046 84.1505 32.2936C84.1184 32.4826 84.1652 32.6765 84.28 32.83C84.3422 32.9064 84.4208 32.9679 84.51 33.01Z",
    fill: "#FBD149"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_60_9805",
    x1: 60.3416,
    y1: 51.1521,
    x2: 80.5125,
    y2: 47.7691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#EEF0F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F7F8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_60_9805",
    x1: 52.78,
    y1: 72.2049,
    x2: 85.86,
    y2: 72.2049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#EEF0F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F7F8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrafficCone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/traffic-cone.c062d345.svg";
export { ForwardRef as ReactComponent };